import { AddDeviceInput } from "../../API";

export const checkDuplicateDeviceNames = (
  existingNames: string[],
  devicesToCreate: AddDeviceInput[]
): AddDeviceInput[] => {
  const updatedNames = new Set(existingNames.map(name => name.toLowerCase()));
  const modifiedDevices: AddDeviceInput[] = [];

  devicesToCreate.forEach(device => {
    let baseName = device.name;
    const match = baseName.match(/^(.*?)(\d+)$/);

    baseName = match ? match[1] : baseName;
    let suffixNum = match ? parseInt(match[2], 10) : 1;
    let newName = `${baseName}${suffixNum}`;

    while (updatedNames.has(newName.toLowerCase())) {
      suffixNum++;

      newName = `${baseName}${suffixNum}`;
    }

    updatedNames.add(newName.toLowerCase());

    modifiedDevices.push({ ...device, name: newName });
  });

  return modifiedDevices;
};
